// sns Icon - fill
import Kakao from "@/assets/images/icons/sns/sign/fill/kakao.svg";
import FB from "@/assets/images/icons/sns/sign/fill/fb.svg";
// import Insta    from '@/assets/images/icons/sns/sign/fill/insta.svg'
import Twitter from "@/assets/images/icons/sns/sign/fill/x.svg";
import Tel from "@/assets/images/icons/sns/sign/fill/tel.svg";
import Youtube from "@/assets/images/icons/sns/sign/fill/youtube.svg";
import Medium from "@/assets/images/icons/sns/sign/fill/medium.svg";
import Naver from "@/assets/images/icons/sns/sign/fill/naver.svg";

// sns Icon - empty
import KakaoE from "@/assets/images/icons/sns/sign/empty/kakao.svg";
import FBE from "@/assets/images/icons/sns/sign/empty/fb.svg";
// import InstaE    from '@/assets/images/icons/sns/sign/empty/insta.svg'
import TwitterE from "@/assets/images/icons/sns/sign/empty/x.svg";
import TelE from "@/assets/images/icons/sns/sign/empty/tel.svg";
import YoutubeE from "@/assets/images/icons/sns/sign/empty/youtube.svg";
import MediumE from "@/assets/images/icons/sns/sign/empty/medium.svg";
import NaverE from "@/assets/images/icons/sns/sign/empty/naver.svg";

// kakao, twitter 만 bg : true

export default {
  namespaced: true,
  state: () => ({
    list: {
      USA: [
        {
          key: "facebook",
          icon: FB,
          activeIcon: FBE,
          bgClass: false,
          isOpen: false,
          link: "",
        },
        {
          key: "twitter",
          icon: Twitter,
          activeIcon: TwitterE,
          bgClass: true,
          isOpen: true,
          link: "https://x.com/risingxofficial",
        },
        {
          key: "telegram",
          icon: Tel,
          activeIcon: TelE,
          bgClass: false,
          isOpen: true,
          link: "https://t.me/+st7GsLLNad9kMjE1",
        },
        {
          key: "youtube",
          icon: Youtube,
          activeIcon: YoutubeE,
          bgClass: false,
          isOpen: true,
          link: "https://www.youtube.com/channel/UC9_bsvjXPn-RjpdlP1l09MA",
        },
        {
          key: "medium",
          icon: Medium,
          activeIcon: MediumE,
          bgClass: false,
          isOpen: true,
          link: "https://medium.com/@risingxofficial",
        },
      ],
      KOR: [
        {
          key: "kakao",
          icon: Kakao,
          activeIcon: KakaoE,
          bgClass: true,
          isOpen: true,
          link: "",
        },
        {
          key: "naver",
          icon: Naver,
          activeIcon: NaverE,
          bgClass: true,
          isOpen: true,
          link: "https://blog.naver.com/risingx_official",
        },
        {
          key: "youtube",
          icon: Youtube,
          activeIcon: YoutubeE,
          bgClass: false,
          isOpen: true,
          link: "https://www.youtube.com/channel/UCxFwE-1e16fXJDKSG5gHwPg ",
        },
        {
          key: "medium",
          icon: Medium,
          activeIcon: MediumE,
          bgClass: false,
          isOpen: true,
          link: "",
        },
      ],
      JPN: [],
      CHN: [],

      VNM: [],
      MYS: [],
      RUS: [],
    },
  }),
  actions: {
    snsItems({ state }) {
      return state.list.USA.filter((ob) => ob.isOpen);
    },
  },
};
